import React from 'react';
import useAddons from '../../../hooks/useAddons';

export default function MultiPoseAddons() {
  const { data: addons } = useAddons();

  return (
    <div></div>
  );
}
